import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router";

import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import img from "../../assets/img/img.png";
import Footer from "../../common/Footer";
import MediaModelApp from "./MediaModal";
import AllMediaModelApp from "./AllMediaShow";
import { getAllJob } from "../Jobhiringpost/jobsApi";
import {
  applyForJob,
  getAllJobsMarketplace,
  getJobProfile,
} from "./jobListApi";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import { getAllJobsMarketplace } from "./jobListApi";
export default function ApplyJob() {
  const [job, setJob] = useState(null);
  const { id } = useParams();
  const token = sessionStorage.getItem("smbToken");

  const [hide, setHide] = useState(false);
  const navigate = useNavigate();
  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }
  const payload = {
    billerId: 0,
    filter: "",
    search: "",
  };
  useEffect(() => {
    if (token) {
      getAllJob(payload, (res) => {
        const jobList = res?.data?.data?.list || [];
        const selectedJob = jobList.find(
          (item) => String(item.id) === String(id),
        );
        setJob(selectedJob);
      });
    } else {
      getAllJobsMarketplace(payload, (res) => {
        const jobList = res?.data?.data?.list || [];
        const selectedJob = jobList.find(
          (item) => String(item.id) === String(id),
        );
        setJob(selectedJob);
      });
    }
  }, [id, token]);

  const handleForJobApply = async () => {
    if (!token) {
      Swal.fire({
        text: "Please Login First",
        icon: "error",
        ...swalAlertPopProps,
      });
      return;
    }
    const res = await getJobProfile();
    const data = res?.data?.data;

    if (!data) {
      Swal.fire({
        text: "Please Create Profile to Apply Job",
        icon: "error",
        ...swalAlertPopProps,
      });
      return;
    }

    applyForJob({ jobId: Number(id) }, (res) => {}).then(() => {
      if (token) {
        getAllJob(payload, (res) => {
          const jobList = res?.data?.data?.list || [];
          const selectedJob = jobList.find(
            (item) => String(item.id) === String(id),
          );
          setJob(selectedJob);
        });
      } else {
        getAllJobsMarketplace(payload, (res) => {
          const jobList = res?.data?.data?.list || [];
          const selectedJob = jobList.find(
            (item) => String(item.id) === String(id),
          );
          setJob(selectedJob);
        });
      }
    });
  };

  return (
    <>
      <Box sx={{ backgroundColor: "#C0BFFF" }}>
        <Box sx={{ minHeight: "100vh", p: { sm: 3, xs: 0 } }}>
          {/* Back Icon */}
          <KeyboardBackspaceIcon
            onClick={() => navigate("/jobs")}
            sx={{ fontSize: 30, color: "#01008B", mb: 2, cursor: "pointer" }}
          />

          {/* Job Card */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              px: { xs: 1.5, sm: 3, md: 10, lg: 20 },
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container alignItems="center" spacing={3}>
                {/* Logo */}
                <Grid item xs={12} sm={4} md={3} lg={3}>
                  <Box
                    component="img"
                    src={img}
                    alt="Job"
                    sx={{
                      width: { xs: "100%", sm: 180, md: 150, lg: 200 },
                      height: { xs: 180, sm: 180, md: 150, lg: 200 },
                      objectFit: "cover",
                      borderRadius: 2,
                    }}
                  />
                </Grid>

                {/* Job Details */}
                <Grid item xs={12} sm={6} md={9} lg={9}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", sm: "22px", md: "38px" },
                      fontWeight: 600,
                    }}
                  >
                    {job?.designation}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "13px", sm: "16px", md: "18px" },
                      fontWeight: 500,
                      mt: 0.5,
                    }}
                  >
                    {job?.enterpriseName}
                  </Typography>

                  <Box sx={{ mt: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 0.5,
                        gap: 2,
                      }}
                    >
                      <Box
                        component="img"
                        src={location}
                        alt="Location"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {job?.preferredLocation}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 0.5,
                        gap: 2,
                      }}
                    >
                      <Box
                        component="img"
                        src={rupees}
                        alt="Salary"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {job?.minSalary} – {job?.maxSalary} / month
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        component="img"
                        src={vacancy}
                        alt="Vacancies"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                        {job?.noOfVacancies} Vacancies
                      </Typography>
                    </Box>

                    <Grid
                      container
                      sx={{
                        position: "absolute",
                        bottom: { xs: 6, sm: 10, md: 20 },
                        right: { xs: 16, sm: 20 },
                        width: {
                          xs: "40%",
                          sm: "40%",
                          md: "30%",
                          lg: job?.hasApplied !== true ? "20%" : "15%",
                        },
                      }}
                    >
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={handleForJobApply}
                          sx={{
                            backgroundColor:
                              job?.hasApplied !== true ? "#01008B" : "green",
                            // py: 1,
                            fontSize: { xs: "13px", sm: "16px", md: "18px" },
                            pointerEvents: job?.hasApplied ? "none" : "auto",
                            borderRadius: "6px",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": {
                              backgroundColor: "#0201b3",
                            },
                          }}
                        >
                          {job?.hasApplied && (
                            <CheckCircleIcon
                              sx={{ fontSize: 20, color: "#2ECC71", mx: 1 }}
                            />
                          )}
                          {job?.hasApplied !== true ? "Apply" : "Applied"}
                        </Button>
                        {/* {job.hasApplied && (
                          <Box
                            sx={{
                              position: "absolute",
                              bottom: 12,
                              right: 16,
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <CheckCircleIcon
                              sx={{ fontSize: 16, color: "#2ECC71" }}
                            />
                            <Typography
                              sx={{
                                fontSize: 13,
                                fontWeight: 600,
                                color: "#2ECC71",
                              }}
                            >
                              Already Applied
                            </Typography>
                          </Box>
                        )} */}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>

                {/* Apply Button */}
                {/* <Grid item>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#01008B",
                  px: 4,
                  py: 1.2,
                  borderRadius: "6px",
                  textTransform: "none",
                  fontWeight: 500,
                  "&:hover": {
                    backgroundColor: "#0201b3",
                  },
                }}
              >
                Apply
              </Button>
            </Grid> */}
              </Grid>
            </Box>

            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Job Description */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Job Description
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.jobDescriptions}
                  </Typography>

                  {/* Expertise */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Expertise
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.expertise}
                  </Typography>

                  {/* Eligibility */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Eligibility
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.eligibility}
                  </Typography>

                  {/* Job For */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Job For
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.gender} Employee
                  </Typography>

                  {/* Job Timing */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Job Timing
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.jobTiming}
                  </Typography>

                  {/* Perks */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Perks and Benefits
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.perksAndBenefits}
                  </Typography>

                  {/* Location */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Job Location
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.preferredLocation}
                  </Typography>

                  {/* Vacancies */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    No. of Vacancies
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666">
                    {job?.noOfVacancies}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Job Description */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Education
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.education}
                  </Typography>

                  {/* Expertise */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Salon Diploma Required:
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.diplomaRequired === true ? "Yes" : "No"}
                  </Typography>

                  {/* Eligibility */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Experience
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.experienceYears} Years {job?.experienceMonths} Months
                  </Typography>

                  {/* Job For */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Salary
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    ₹{job?.minSalary} – ₹{job?.maxSalary} Per Month
                  </Typography>

                  {/* Job Timing */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Incentive
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.incentive === true ? "Yes" : "No"}
                  </Typography>

                  {/* Perks */}
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Job Description */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Salon Area
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.area}
                  </Typography>

                  {/* Expertise */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Salon Mobile No.
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.businessMobileNumber}
                  </Typography>

                  {/* Eligibility */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:'16px'}} mb={0.5}>
                    Contact Person Mobile No.
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.mobileNumber}
                  </Typography>

                  <Button
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: "6px",
                      px: 2.5,
                      py: 0.8,
                      borderColor: "#01008B",
                      color: "#01008B",
                    }}
                    onClick={() => {
                      setHide(true);
                    }}
                  >
                    Social Media Links
                  </Button>
                </Grid>
              </Grid>
            </Box>
            <AllMediaModelApp
              open={hide}
              setOpen={setHide}
              modelData={{
                google: "",
                website: "",
                instagram: "",
                facebook: "",
                youTube: "",
                pinterest: "",
                twitter: "",
                linkedIn: "",
                // ...MyBusinessData,
              }}
              // setModalData={setMyBussinessData}
            />
          </Box>
        </Box>
        <Box sx={{ pt: 5 }}>
          <Footer />
        </Box>
      </Box>
    </>
  );
}
